module.exports = __webpack_public_path__ + "img/whatsapp-icone.1f3b468b.png";